"use client"

import { Heading, Text } from "@chakra-ui/react"
import { Box } from "@chakra-ui/react/box"
import { Flex } from "@chakra-ui/react/flex"
import { Link } from "@chakra-ui/react/link"
import { HStack, Stack, VStack } from "@chakra-ui/react/stack"
import parse from "html-react-parser"

import MarkdownParser from "@/components/MarkdownParser"
import { ConsultingProject } from "@/types/getAbout"
import { getSafeHtmlParserOptions } from "@/utils/getSafeHtmlParserOptions"
import { GlobeIcon } from "@/components/icons"

interface AccordionConsultingProjectCardProps {
  project: ConsultingProject
}

const AccordionConsultingProjectCard = ({
  project,
}: AccordionConsultingProjectCardProps) => {
  return (
    <VStack
      _dark={{
        background: "gray.800",
        borderColor: "gray.700",
      }}
      alignItems="flex-start"
      background="grey.100"
      border="1px solid"
      borderColor="gray.200"
      borderRadius={16}
      gap={4}
      padding={4}
      width="100%"
    >
      <HStack>
        <Flex
          _dark={{
            borderColor: "gray.700",
          }}
          alignContent="center"
          alignItems="center"
          bg="white"
          borderColor="gray.100"
          borderRadius={"lg"}
          borderWidth="1px"
          css={{
            "& svg": {
              height: "40px",
              width: "40px",
            },
          }}
          flexDirection="column"
          height="54px"
          justifyContent="center"
          maxH="54px"
          minW="54px"
          padding={1}
          width="54px"
        >
          {parse(project.company.svg_logo, getSafeHtmlParserOptions())}
        </Flex>
        <VStack
          alignItems={"flex-start"}
          gap={0}
          justifyContent={"flex-start"}
          pl={3}
        >
          <Text color="gray.400" fontSize={["xs", "sm", "sm"]} textAlign="left">
            {project.title + " as " + project.role}
          </Text>
          <Link
            _dark={{
              color: "primary.200",
            }}
            color="primary.500"
            gap={1}
            href={project.company.url}
            target="_blank"
          >
            <Heading
              as="h3"
              lineHeight={{ base: "1.2", md: "1.5" }}
              size={["xs", "xs", "sm"]}
              textAlign="left"
            >
              {project.company.name}
            </Heading>
            <Box color={"currentColor"} display="inline-flex" marginRight={1}>
              <GlobeIcon boxSize="12px" />
            </Box>
          </Link>
        </VStack>
      </HStack>
      <VStack alignItems="flex-start" width="100%">
        <Stack direction={{ base: "column", lg: "row" }}>
          <MarkdownParser fontSize="sm" markdown={project.description} />
        </Stack>
      </VStack>
    </VStack>
  )
}

export default AccordionConsultingProjectCard
